import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Field from 'common/components/Form/Field';
import { t } from 'translates';

class DeliveryInformation extends Component {
  static propTypes = {
    countries: PropTypes.array.isRequired,
    states: PropTypes.array.isRequired,
    onChangeCountry: PropTypes.func.isRequired,
    getCountries: PropTypes.func.isRequired,
    checkPairValidity: PropTypes.func.isRequired,
    pairValidationInit: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    formErrors: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.onChangeCountry = this.onChangeCountry.bind(this);
    this.onChangeSate = this.onChangeSate.bind(this);
    this.onInput = this.onInput.bind(this);

    this.domainCheck = window.drupalSettings
      && window.drupalSettings.domainId
      && window.drupalSettings.domainId === 'lecole_japan';
  }

  componentDidMount() {
    this.props.getCountries();
    this.props.pairValidationInit();
  }

  onChangeCountry(e) {
    const { form } = this.props;
    e.preventDefault();
    this.props.onChangeCountry(e.target.value);
    this.onInput(e, 'country_code');
    form.change('delivery_administrative_area', '');
  }

  onChangeSate(e) {
    e.preventDefault();
    this.onInput(e, 'administrative_area');
  }

  onInput(e) {
    e.preventDefault();
    if (e.target.getAttribute('pairname')) {
      this.props.checkPairValidity(e.target);
    }
  }

  render() {
    const {
      countries,
      states,
      values,
      formErrors,
    } = this.props;

    return (
      <div className="gift-modal-dialog__body-fieldset">
        <Field
          name="delivery_address_line1"
          placeholder={t('Address (1)', DT_GIFT)}
          onInput={this.onInput}
          value=""
          required
          formError={formErrors['delivery_address_line1']}
        />
        <Field
          name="delivery_address_line2"
          placeholder={t('Address (2)', DT_GIFT)}
          onInput={this.onInput}
          value=""
          formError={formErrors['delivery_address_line2']}
        />
        <Field
          type="select"
          name="delivery_country_code"
          placeholder={t('Country', DT_GIFT)}
          required
          onChange={this.onChangeCountry}
          value={values && values.delivery_country_code ? values.delivery_country_code : ""}
          filter
          formError={formErrors['delivery_country_code']}
        >
          <option value="" hidden />
          {countries.map(({ iso_code, name }) => (
            <option key={iso_code} value={iso_code} countryname={name}>
              {name}
            </option>
          ))}
        </Field>
        <Field
          type="select"
          name="delivery_administrative_area"
          placeholder={t('State', DT_GIFT)}
          disabled={!states.length}
          onChange={this.onInput}
          value={values && values.delivery_administrative_area ? values.delivery_administrative_area : ""}
          formError={formErrors['delivery_administrative_area']}
        >
          <option value="" hidden />
          {states.map(({ code, name }) => (
            <option key={code} value={code}>
              {name}
            </option>
          ))}
        </Field>

        <Field
          name="delivery_locality"
          placeholder={t('City', DT_GIFT)}
          onInput={this.onInput}
          value=""
          required
          formError={formErrors['delivery_locality']}
        />
        <Field
          name="delivery_postal_code"
          placeholder={t('Zip Code', DT_GIFT)}
          onInput={this.onInput}
          value=""
          required
          formError={formErrors['delivery_postal_code']}
        />

      </div>
    );
  }
}

export default DeliveryInformation;
